import { FC, ReactNode, Fragment } from 'react';

import { Dialog as HeadlessUiDialog, Transition } from '@headlessui/react';

import styles from './Dialog.module.scss';

// View
type DialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  addClass?: string[];
  easyCloseMode?: boolean;
  children?: ReactNode;
};

/**
 * ダイアログコンポーネント
 * @desc [headless UI のDialog(Modal)](https://headlessui.com/react/dialog)を使用
 */
export const Dialog: FC<DialogProps> = ({
  isOpen,
  easyCloseMode = true,
  addClass = [],
  children,
  handleClose,
}) => {
  // 背景タップで閉じたくない場合はnoopを使用する
  const _noop = (..._args: unknown[]) => {
    // do nothing.
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <HeadlessUiDialog
        as="div"
        className={[styles.dialog, ...addClass].join(' ')}
        onClose={!easyCloseMode ? _noop : handleClose}
      >
        <Transition.Child
          as={Fragment}
          enter={styles.enter}
          enterFrom={styles.enterFrom}
          enterTo={styles.enterTo}
          leave={styles.leave}
          leaveFrom={styles.leaveFrom}
          leaveTo={styles.leaveTo}
        >
          <div className={styles.screen}></div>
        </Transition.Child>

        <Transition.Child
          as={Fragment}
          enter={styles.enter}
          enterFrom={styles.enterFrom}
          enterTo={`--isOpen ${styles.enterTo}`}
          leave={styles.leave}
          leaveFrom={styles.leaveFrom}
          leaveTo={styles.leaveTo}
        >
          <HeadlessUiDialog.Panel
            className={!addClass.length ? styles.content : styles.contentWrapper}
          >
            {children}
          </HeadlessUiDialog.Panel>
        </Transition.Child>
      </HeadlessUiDialog>
    </Transition>
  );
};
